import React from 'react'
import { DialogPopupProps } from './DialogPopup.types'
import styles from './DialogPopup.module.scss'
import cl from 'classnames'
import { PopupContainer } from '../PopupContainer'
import { SectionContainer } from '../SectionContainer'
import { HorizontalLine } from '../HorizontalLine'
import { Button } from '../Button'
import { H1 } from '../H1'
import { Text1 } from '../Text1'
import { getIconAndHeading } from './DialogPopup.utils'
import { inject } from 'mobx-react'
import { GENERAL_STORE } from 'store'

const DialogPopupComponent = (props: DialogPopupProps) => {
  const {
    className,
    style,
    type,
    heading,
    message,
    children,
    onClose,
    closeButtonLabel = 'Close',
    buttons = [],
    [GENERAL_STORE]: {
      closeDialogPopup
    }
  } = props

  const { icon: Icon, defaultHeading } = getIconAndHeading(type)

  const onCloseClick = () => {
    onClose && onClose()
    closeDialogPopup()
  }

  return (
    <PopupContainer
      className={cl(styles.container, className)}
      style={style}
    >
      <SectionContainer className={styles.section}>
        <Icon style={{ marginTop: 15 }} />
        <H1 bold style={{ marginTop: 12 }}>{heading || defaultHeading}</H1>
        <Text1 className={styles.message}>
          {message}
        </Text1>
        {children}
        <HorizontalLine className={styles.line} />
        <div className={styles.buttonsContainer}>
          <Button
            preset='secondary'
            onClick={onCloseClick}
          >
            {closeButtonLabel}
          </Button>
          {buttons.map((bttnProps, index) => (
            <Button key={index} {...bttnProps} />
          ))}
        </div>
      </SectionContainer>
    </PopupContainer>
  )
}

const DialogPopup = inject(
  GENERAL_STORE
)(DialogPopupComponent)
export { DialogPopup }
